"use client";

import { motion } from "framer-motion";
import { useMemo } from "react";
import { cn } from "@/lib/utils";
import { buildNotchPath } from "./BottomNavConstants";

/**
 * The dark bar behind the bottom nav, with a single "dip" cut out of its top
 * edge to cradle the active item's raised circle. `dipCenter` is the exact
 * horizontal centre of the active item, in the SVG's 428-wide viewBox units —
 * it is measured from the real layout by `BottomNav`, so the dip stays under
 * the active circle at every width and in both LTR and RTL (no mirror needed).
 */
export const BottomNavNotch = ({ dipCenter }: { dipCenter: number }) => {
  const d = useMemo(() => buildNotchPath(dipCenter), [dipCenter]);

  return (
    <svg
      className={cn(
        "absolute bottom-0 z-10 h-[75px]",
        "bg-bg-primary",
        "w-full max-w-107 shrink-0 rounded-[26px]",
      )}
      viewBox="0 0 428 75"
      preserveAspectRatio="none"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <motion.path
        fill="var(--bg-secondary)"
        initial={false}
        animate={{ d }}
        transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1], type: "tween" }}
      />
    </svg>
  );
};
